module.exports = __webpack_public_path__ + "media/site/images/contact-slider/contact_slideshow-11-de4560b98b3069eff7192c5ef8f797e7.jpg";